export const recordStatuses = {
  DRAFT: "Draft",
  PREVIEW: "Preview",
  PUBLISHED: "Published",
  ARCHIVED: "Archived",
};

export const isLocalOrStaging = window.location.host.startsWith("staging") || window.location.host.startsWith("localhost");
